import ScrollManager from './utils/scroll-manager';

const PopinVideo = {
    init() {
        /*
        .video_embed = iframe originale générée pour chaque cta vidéo
        .video_embedded = iframe unique dans popin, résultat du clonage de .video_embed
        */

        const popinVideo = $('.popin_video');
        const target = popinVideo.find('.video_embedded');

        // slider témoignage OU strate-header-cpt-temoignage OU strate-2-col-texte-image OU Carriere OU strate-maillage-autres-temoignages
        if ($('.slide_temoignage').length > 0
            || $('.strate-header-cpt-temoignage').length > 0
            || $('.strate-2-col-texte-image').length > 0
            || $('.strate-archive-blog').length > 0
            || $('.strate-maillage-autres-temoignages').length > 0
        ) {

            $('.js_player_video_popin').click(
                function () {
                    const video = $(this).parent().parent().find('.video_embed noscript').html();

                    target.append(video);
                    /*
                    bug : les css ne s'appliqent pas à l'iframe ?
                    Je "force" les css en js...
                    */
                    $(target).find('iframe').css(
                        {
                            width: '80%',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }
                    );

                    ScrollManager.preventScroll(true);
                    popinVideo.addClass('activate');
                    $(target).find('iframe')[0].src;

                    return false;
                }
            );
        }

        // Page carriere Header Carriere
        if ($('.header-carriere').length > 0) {
            $('.js_player_video_popin_carriere').click(
                function () {
                    const video = $(this).find('.video_embed noscript').html();
                    target.append(video);
                    /*
                    bug : les css ne s'appliqent pas à l'iframe ?
                    Je "force" les css en js...
                    */
                    $(target).find('iframe').css(
                        {
                            width: '80%',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                        }
                    );
                    ScrollManager.preventScroll(true);
                    popinVideo.addClass('activate');
                    $(target).find('iframe')[0].src += '&autoplay=1';

                    return false;
                }
            );
        }

        $('.close_video').on(
            'click', evt => {
                coreCloseVideo(popinVideo, target);
                return false;
            }
        );

        $(document).on(
            'keydown', evt => {
                if (evt.key === 'Escape' && popinVideo.hasClass('activate')) {
                    coreCloseVideo(popinVideo, target);
                }
            }
        );

        const coreCloseVideo = (popin, popinTarget) => {
            popin.removeClass('activate');
            $(popinTarget).find('iframe').attr('src', $(popinTarget).find('iframe').attr('src').replace('&autoplay=1', ''));
            popin.find('.video_embedded').empty();
            ScrollManager.preventScroll(false);
        };
    },
};

export default PopinVideo;
